/* eslint-disable import/prefer-default-export, import/no-named-as-default */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';

const useConsultancies = (props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };
  const {
    isLoading, data, error, refetch,
  } = useQuery({
    queryKey: QueryKeys.CONSULTANCIES,
    queryFn: async () => API.getInstance().getConsultancies().then((response) => response.data),
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const consultanciesOptions = React.useMemo(
    () => data?.map((option) => ({ label: option.name, value: option.id })) || [],
    [data],
  );

  return {
    consultanciesLoading: isLoading,
    consultanciesOptions,
    data,
    error,
    fetchConsultancies: refetch,
  };
};

export {
  useConsultancies,
};
